/* TOKYO LILY RENEWAL — shared behaviors */
(function () {
  'use strict';

  /* ── スクロールリビール ── */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.rv:not(.on)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('on'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── ダークモードトグル（F-6）── */
  function initThemeToggle() {
    document.querySelectorAll('[data-tl-theme-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var html = document.documentElement;
        var next = html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        html.setAttribute('data-theme', next);
        /* 旧テーマの配色（data-scheme / _color_schema）も一緒に切り替える。
           これを揃えないと旧マークアップのページだけ OS のダークモードに
           引きずられて黒背景・白文字になる（theme.liquid の FOUC 対策と対）。 */
        html.setAttribute('data-scheme', next);
        try { localStorage.setItem('tl-theme', next); } catch (e) { /* private mode */ }
        try { localStorage.setItem('_color_schema', next); } catch (e) { /* private mode */ }
        btn.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
      });
    });
  }

  /* ── モバイルドロワー ── */
  function initDrawer() {
    var btn = document.getElementById('hdMbBtn');
    var drawer = document.getElementById('hdMbDrawer');
    if (!btn || !drawer) return;
    function close() {
      btn.classList.remove('open');
      drawer.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    btn.addEventListener('click', function () {
      var isOpen = drawer.classList.toggle('open');
      btn.classList.toggle('open', isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 768 && drawer.classList.contains('open')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
  }

  /* ── 撮影会カテゴリフィルタ（TOP / 撮影会一覧 共用）──
     コンテナ: [data-session-filter]
     タブ: .cat-tab[data-cat]、カード: .sc[data-cat]、日付ブロック: .sg-block + .date-sep[data-group] */
  function initSessionFilter() {
    document.querySelectorAll('[data-session-filter]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('.cat-tab[data-cat]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var cat = tab.dataset.cat;
          tabs.forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');
          wrap.querySelectorAll('.sc[data-cat]').forEach(function (c) {
            c.style.display = (cat === 'all' || c.dataset.cat === cat) ? '' : 'none';
          });
          wrap.querySelectorAll('.sg-block').forEach(function (sg) {
            var visible = Array.prototype.some.call(sg.querySelectorAll('.sc'), function (c) {
              return c.style.display !== 'none';
            });
            sg.style.display = visible ? '' : 'none';
            var sep = wrap.querySelector('.date-sep[data-group="' + sg.id + '"]');
            if (sep) sep.style.display = visible ? '' : 'none';
          });
        });
      });
    });
  }

  function initAll() {
    initReveal(document);
    initThemeToggle();
    initDrawer();
    initSessionFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* テーマエディタでセクションが再描画された時にも効かせる */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initSessionFilter();
    initDrawer();
    initThemeToggle();
  });

  window.TokyoLily = { initReveal: initReveal };
})();
